// This file is auto-generated. Do not edit manually.
// Generated on 2025-03-17T18:04:23.983Z

interface ModelSpecificSettings {
    setting_id?: string;
    compatible_printers?: string[];
    [key: string]: any;
}

interface FilamentTypeSettings {
    filament_id: string;
    vendor: string;
    base_settings: {
        [key: string]: any;
    };
    model_settings: {
        [printerModel: string]: ModelSpecificSettings;
    };
}

interface FilamentMapping {
    [materialType: string]: FilamentTypeSettings;
}

export const FILAMENT_MAPPINGS: FilamentMapping = {
  "ABS": {
    "filament_id": "GFB00",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "When printing this filament, there's a risk of warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials.",
      "filament_cost": [
        "24.99"
      ],
      "filament_flow_ratio": [
        "0.95"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB00_07",
        "instantiation": "true",
        "fan_max_speed": [
          "20"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "16"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "slow_down_layer_time": [
          "12"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSB00",
        "instantiation": "true",
        "fan_max_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "16"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "slow_down_layer_time": [
          "12"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSB00_04",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle"
        ]
      }
    }
  },
  "ABS-GF": {
    "filament_id": "GFB50",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials.",
      "fan_cooling_layer_time": [
        "12"
      ],
      "fan_max_speed": [
        "30"
      ],
      "filament_cost": [
        "29.99"
      ],
      "filament_density": [
        "1.08"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_type": [
        "ABS-GF"
      ],
      "overhang_fan_speed": [
        "30"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "slow_down_layer_time": [
        "4"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB50_02",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSB50_01",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSB50_00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "ASA": {
    "filament_id": "GFB01",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "When printing this filament, there's a risk of warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials.",
      "fan_max_speed": [
        "35"
      ],
      "filament_cost": [
        "31.99"
      ],
      "filament_density": [
        "1.05"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "18"
      ],
      "nozzle_temperature": [
        "270"
      ],
      "nozzle_temperature_initial_layer": [
        "270"
      ],
      "slow_down_layer_time": [
        "12"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSB01_00",
        "instantiation": "true",
        "fan_min_speed": [
          "25"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab P1P 0.6 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSB01_05",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "ASA-Aero": {
    "filament_id": "GFB02",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "This filament is only used to print models with a low density usually, and some special parameters are required. To get better printing quality, please refer to this wiki: ASA Aero Printing Guide.",
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "50"
      ],
      "fan_min_speed": [
        "30"
      ],
      "filament_cost": [
        "49.99"
      ],
      "filament_density": [
        "0.99"
      ],
      "filament_flow_ratio": [
        "0.52"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_retraction_length": [
        "1.5"
      ],
      "filament_type": [
        "ASA-Aero"
      ],
      "filament_wipe_distance": [
        "5"
      ],
      "filament_z_hop_types": [
        "Normal Lift"
      ],
      "nozzle_temperature": [
        "270"
      ],
      "nozzle_temperature_initial_layer": [
        "270"
      ],
      "overhang_fan_speed": [
        "50"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "slow_down_layer_time": [
        "5"
      ],
      "filament_scarf_seam_type": [
        "none"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB02_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSB02_01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSB02_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "ASA-CF": {
    "filament_id": "GFB51",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "fan_max_speed": [
        "25"
      ],
      "filament_cost": [
        "36.99"
      ],
      "filament_density": [
        "1.02"
      ],
      "filament_flow_ratio": [
        "0.9"
      ],
      "filament_max_volumetric_speed": [
        "18"
      ],
      "filament_type": [
        "ASA-CF"
      ],
      "nozzle_temperature": [
        "275"
      ],
      "nozzle_temperature_initial_layer": [
        "275"
      ],
      "nozzle_temperature_range_low": [
        "250"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "temperature_vitrification": [
        "108"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB51_04",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSB51_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSB51_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "PA-CF": {
    "filament_id": "GFN03",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials.",
      "filament_cost": [
        "84.99"
      ],
      "filament_density": [
        "1.09"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_type": [
        "PA-CF"
      ],
      "nozzle_temperature": [
        "280"
      ],
      "nozzle_temperature_initial_layer": [
        "280"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "temperature_vitrification": [
        "170"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSN03_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "5"
        ],
        "fan_max_speed": [
          "30"
        ],
        "fan_min_speed": [
          "10"
        ],
        "full_fan_speed_layer": [
          "2"
        ],
        "nozzle_temperature": [
          "290"
        ],
        "nozzle_temperature_initial_layer": [
          "290"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSN00",
        "instantiation": "true",
        "nozzle_temperature_initial_layer": [
          "290"
        ],
        "nozzle_temperature": [
          "290"
        ],
        "fan_max_speed": [
          "30"
        ],
        "fan_min_speed": [
          "10"
        ],
        "fan_cooling_layer_time": [
          "5"
        ],
        "full_fan_speed_layer": [
          "2"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSN03_00",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "PA6-CF": {
    "filament_id": "GFN05",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials.",
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "79.99"
      ],
      "filament_density": [
        "1.10"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_type": [
        "PA6-CF"
      ],
      "nozzle_temperature": [
        "275"
      ],
      "nozzle_temperature_initial_layer": [
        "275"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "temperature_vitrification": [
        "170"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSN05_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSN05_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSN05_03",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "PA6-GF": {
    "filament_id": "GFN08",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials.",
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "59.99"
      ],
      "filament_density": [
        "1.14"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_type": [
        "PA-GF"
      ],
      "full_fan_speed_layer": [
        "2"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "temperature_vitrification": [
        "180"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSN08_02",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "10.5"
        ],
        "nozzle_temperature": [
          "265"
        ],
        "nozzle_temperature_initial_layer": [
          "265"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSN08_01",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "10.5"
        ],
        "nozzle_temperature": [
          "265"
        ],
        "nozzle_temperature_initial_layer": [
          "265"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSN08_00",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "10.5"
        ],
        "nozzle_temperature": [
          "265"
        ],
        "nozzle_temperature_initial_layer": [
          "265"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "PAHT-CF": {
    "filament_id": "GFN04",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials.",
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "94.99"
      ],
      "filament_density": [
        "1.06"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_type": [
        "PA-CF"
      ],
      "full_fan_speed_layer": [
        "2"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "temperature_vitrification": [
        "180"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSN04_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSN04",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "PC": {
    "filament_id": "GFC00",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "39.99"
      ],
      "filament_flow_ratio": [
        "0.94"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSC00_14",
        "instantiation": "true",
        "eng_plate_temp": [
          "100"
        ],
        "eng_plate_temp_initial_layer": [
          "100"
        ],
        "fan_max_speed": [
          "20"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "slow_down_layer_time": [
          "12"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "P1S": {
        "setting_id": "GFSC00_05",
        "instantiation": "true",
        "eng_plate_temp": [
          "100"
        ],
        "eng_plate_temp_initial_layer": [
          "100"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSC00",
        "instantiation": "true",
        "fan_max_speed": [
          "40"
        ],
        "slow_down_layer_time": [
          "12"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSC00_12",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "PET-CF": {
    "filament_id": "GFT01",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials.",
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "eng_plate_temp": [
        "80"
      ],
      "eng_plate_temp_initial_layer": [
        "80"
      ],
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "84.99"
      ],
      "filament_density": [
        "1.29"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_type": [
        "PET-CF"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature": [
        "270"
      ],
      "nozzle_temperature_initial_layer": [
        "270"
      ],
      "nozzle_temperature_range_high": [
        "290"
      ],
      "nozzle_temperature_range_low": [
        "260"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "supertack_plate_temp": [
        "80"
      ],
      "supertack_plate_temp_initial_layer": [
        "80"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "temperature_vitrification": [
        "185"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFST01_01",
        "instantiation": "true",
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "slow_down_min_speed": [
          "20"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.8 nozzle",
          "Bambu Lab A1 0.6 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFST01",
        "instantiation": "true",
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "slow_down_min_speed": [
          "20"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFST01_00",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "PETG Basic": {
    "filament_id": "GFG00",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "To get better transparent or translucent results with the corresponding filament, please refer to this wiki: Printing tips for transparent PETG.",
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "40"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "24.99"
      ],
      "filament_density": [
        "1.25"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature_range_low": [
        "230"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG00_06",
        "instantiation": "true",
        "filament_flow_ratio": [
          "0.94"
        ],
        "filament_max_volumetric_speed": [
          "9"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSG00_01",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "13"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "PETG HF": {
    "filament_id": "GFG02",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "40"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "24.99"
      ],
      "filament_density": [
        "1.28"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "21"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature": [
        "245"
      ],
      "nozzle_temperature_initial_layer": [
        "230"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature_range_low": [
        "230"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG02_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "15"
        ],
        "fan_max_speed": [
          "50"
        ],
        "fan_min_speed": [
          "30"
        ],
        "filament_flow_ratio": [
          "0.94"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "18"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "nozzle_temperature": [
          "240"
        ],
        "overhang_fan_speed": [
          "100"
        ],
        "slow_down_layer_time": [
          "7"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSG02_06",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "15"
        ],
        "fan_max_speed": [
          "50"
        ],
        "fan_min_speed": [
          "30"
        ],
        "filament_flow_ratio": [
          "0.94"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "18"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "nozzle_temperature": [
          "240"
        ],
        "overhang_fan_speed": [
          "100"
        ],
        "slow_down_layer_time": [
          "7"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSG02_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "20"
        ],
        "fan_min_speed": [
          "20"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "overhang_fan_speed": [
          "100"
        ],
        "slow_down_layer_time": [
          "10"
        ],
        "slow_down_min_speed": [
          "20"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "PETG Translucent": {
    "filament_id": "GFG01",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "To get better transparent or translucent results with the corresponding filament, please refer to this wiki: Printing tips for transparent PETG.",
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "24.99"
      ],
      "filament_density": [
        "1.25"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature": [
        "245"
      ],
      "nozzle_temperature_initial_layer": [
        "250"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature_range_low": [
        "230"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG01_05",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "filament_retraction_length": [
          "0.3"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSG01_02",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "filament_retraction_length": [
          "0.3"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSG01_00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "filament_retraction_length": [
          "0.3"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "PETG-CF": {
    "filament_id": "GFG50",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "34.99"
      ],
      "filament_density": [
        "1.25"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "14"
      ],
      "filament_type": [
        "PETG-CF"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "slow_down_layer_time": [
        "6"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1M": {
        "setting_id": "GFSG50_00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "9"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSG50_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "30"
        ],
        "fan_max_speed": [
          "40"
        ],
        "fan_min_speed": [
          "5"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "11.5"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "overhang_fan_speed": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "PLA Aero": {
    "filament_id": "GFA11",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "This filament is only used to print models with a low density usually, and some special parameters are required. To get better printing quality, please refer to this wiki: Instructions for printing RC model with foaming PLA (PLA Aero).",
      "fan_min_speed": [
        "30"
      ],
      "filament_cost": [
        "44.99"
      ],
      "filament_density": [
        "1.21"
      ],
      "filament_flow_ratio": [
        "0.6"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_type": [
        "PLA-AERO"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "nozzle_temperature_range_low": [
        "210"
      ],
      "nozzle_temperature_range_high": [
        "260"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA11_04",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "0"
        ],
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA11_03",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "0"
        ],
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSA11_00",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "0"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA11_01",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "0"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "PLA Basic": {
    "filament_id": "GFA00",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "24.99"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_max_volumetric_speed": [
        "21"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "compatible_printers": [],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA00_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA00_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSA04",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "21"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA00",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "21"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "PLA Dynamic": {
    "filament_id": "GFA13",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "31.99"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA13_05",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_flow_ratio": [
          "0.98"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA13_08",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_flow_ratio": [
          "0.98"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSA13_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "filament_flow_ratio": [
          "0.98"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA13_00",
        "instantiation": "true",
        "filament_flow_ratio": [
          "0.98"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "PLA Galaxy": {
    "filament_id": "GFA15",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "29.99"
      ],
      "filament_density": [
        "1.19"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_max_volumetric_speed": [
        "21"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA15_05",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA15_07",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSA15_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA15_00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "PLA Glow": {
    "filament_id": "GFA12",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "29.99"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_max_volumetric_speed": [
        "18"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA12_11",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSA12_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSA12_08",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA12_00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "X1E": {
        "setting_id": "GFSA12_04",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "PLA Impact": {
    "filament_id": "GFA03",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "25.4"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSA03",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "23.2"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle"
        ]
      }
    }
  },
  "PLA Marble": {
    "filament_id": "GFA07",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "29.99"
      ],
      "filament_density": [
        "1.22"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA07_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA07_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSA07_01",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA07_00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "PLA Matte": {
    "filament_id": "GFA01",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "24.99"
      ],
      "filament_density": [
        "1.32"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "5%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA01_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "22"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA01_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "22"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSA05",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "22"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "X1C": {
        "setting_id": "GFSA01",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "22"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "PLA Metal": {
    "filament_id": "GFA02",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "To make the prints get higher gloss, please dry the filament before use, and set the outer wall speed to be 40 to 60 mm/s when slicing.",
      "filament_cost": [
        "29.99"
      ],
      "filament_density": [
        "1.25"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA02_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA02_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSA02_02",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "21"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA02",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "21"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "PLA Silk": {
    "filament_id": "GFA05",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "To make the prints get higher gloss, please dry the filament before use, and set the outer wall speed to be 40 to 60 mm/s when slicing.",
      "filament_cost": [
        "29.99"
      ],
      "filament_density": [
        "1.32"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_scarf_height": [
        "5%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "nozzle_temperature": [
        "230"
      ],
      "nozzle_temperature_initial_layer": [
        "230"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA05_05",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA05_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "60"
        ],
        "textured_plate_temp_initial_layer": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSA05_02",
        "instantiation": "true",
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA05_01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "PLA Sparkle": {
    "filament_id": "GFA08",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "29.99"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA08_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA08_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSA08_01",
        "instantiation": "true",
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA08_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "PLA Tough": {
    "filament_id": "GFA09",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "28.99"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA09_05",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA09_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSA09_01",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "21"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA09_02",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "21"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "PLA-CF": {
    "filament_id": "GFA50",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "additional_cooling_fan_speed": [
        "0"
      ],
      "cool_plate_temp": [
        "45"
      ],
      "cool_plate_temp_initial_layer": [
        "45"
      ],
      "filament_cost": [
        "34.99"
      ],
      "filament_density": [
        "1.22"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_type": [
        "PLA-CF"
      ],
      "nozzle_temperature_range_low": [
        "210"
      ],
      "nozzle_temperature_range_high": [
        "250"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "supertack_plate_temp": [
        "50"
      ],
      "supertack_plate_temp_initial_layer": [
        "50"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA50_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "15"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "nozzle_temperature": [
          "230"
        ],
        "nozzle_temperature_initial_layer": [
          "230"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA50_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "15"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "nozzle_temperature": [
          "230"
        ],
        "nozzle_temperature_initial_layer": [
          "230"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA50_01",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "15"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "nozzle_temperature": [
          "230"
        ],
        "nozzle_temperature_initial_layer": [
          "230"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "PPA-CF": {
    "filament_id": "GFN06",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSN06_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSN06_01",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "PPS-CF": {
    "filament_id": "GFT02",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials.",
      "fan_max_speed": [
        "30"
      ],
      "filament_cost": [
        "175"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_type": [
        "PPS-CF"
      ],
      "nozzle_temperature_range_low": [
        "310"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "temperature_vitrification": [
        "220"
      ]
    },
    "model_settings": {
      "X1E": {
        "setting_id": "GFST02_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "PVA": {
    "filament_id": "GFS04",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "This is a water-soluble support filament, and usually it is only for the support structure and not for the model body. Printing this filament is of many requirements, and to get better printing quality, please refer to this wiki: PVA Printing Guide.",
      "filament_cost": [
        "79.98"
      ],
      "filament_density": [
        "1.27"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "nozzle_temperature_range_high": [
        "250"
      ],
      "nozzle_temperature_range_low": [
        "210"
      ],
      "slow_down_layer_time": [
        "7"
      ],
      "slow_down_min_speed": [
        "20"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS04_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "nozzle_temperature": [
          "240"
        ],
        "nozzle_temperature_initial_layer": [
          "240"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSS04_06",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "nozzle_temperature": [
          "240"
        ],
        "nozzle_temperature_initial_layer": [
          "240"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSS04_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "nozzle_temperature": [
          "240"
        ],
        "nozzle_temperature_initial_layer": [
          "240"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSS04_00",
        "instantiation": "true",
        "nozzle_temperature": [
          "240"
        ],
        "nozzle_temperature_initial_layer": [
          "240"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Support For PA PET": {
    "filament_id": "GFS03",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "This is a non-water-soluble support filament, and usually it is only for the support structure and not for the model body. To get better printing quality, please refer to this wiki: Printing Tips for Support Filament and Support Function.",
      "fan_cooling_layer_time": [
        "10"
      ],
      "filament_cost": [
        "34.99"
      ],
      "filament_density": [
        "1.22"
      ],
      "filament_is_support": [
        "1"
      ],
      "nozzle_temperature": [
        "280"
      ],
      "nozzle_temperature_initial_layer": [
        "280"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "slow_down_layer_time": [
        "6"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS03_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSS03_00",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Support For PLA": {
    "filament_id": "GFS02",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "This is a non-water-soluble support filament, and usually it is only for the support structure and not for the model body. To get better printing quality, please refer to this wiki: Printing Tips for Support Filament and Support Function.",
      "cool_plate_temp": [
        "40"
      ],
      "cool_plate_temp_initial_layer": [
        "40"
      ],
      "filament_cost": [
        "69.98"
      ],
      "filament_density": [
        "1.30"
      ],
      "filament_is_support": [
        "1"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS02_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSS02_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "textured_plate_temp": [
          "60"
        ],
        "textured_plate_temp_initial_layer": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSS02_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Support For PLA-PETG": {
    "filament_id": "GFS05",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "This is a non-water-soluble support filament, and usually it is only for the support structure and not for the model body. To get better printing quality, please refer to this wiki: Printing Tips for Support Filament and Support Function.",
      "fan_cooling_layer_time": [
        "80"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "20"
      ],
      "filament_cost": [
        "69.98"
      ],
      "filament_density": [
        "1.19"
      ],
      "filament_is_support": [
        "1"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "hot_plate_temp": [
        "60"
      ],
      "hot_plate_temp_initial_layer": [
        "60"
      ],
      "nozzle_temperature": [
        "210"
      ],
      "nozzle_temperature_initial_layer": [
        "210"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "textured_plate_temp": [
        "60"
      ],
      "textured_plate_temp_initial_layer": [
        "60"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS05_06",
        "instantiation": "true",
        "eng_plate_temp": [
          "65"
        ],
        "eng_plate_temp_initial_layer": [
          "65"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSS05_04",
        "instantiation": "true",
        "eng_plate_temp": [
          "65"
        ],
        "eng_plate_temp_initial_layer": [
          "65"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSS05_02",
        "instantiation": "true",
        "eng_plate_temp": [
          "65"
        ],
        "eng_plate_temp_initial_layer": [
          "65"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSS05_00",
        "instantiation": "true",
        "eng_plate_temp": [
          "60"
        ],
        "eng_plate_temp_initial_layer": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Support G": {
    "filament_id": "GFS01",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "This is a non-water-soluble support filament, and usually it is only for the support structure and not for the model body. To get better printing quality, please refer to this wiki: Printing Tips for Support Filament and Support Function.",
      "fan_cooling_layer_time": [
        "10"
      ],
      "filament_cost": [
        "34.99"
      ],
      "filament_density": [
        "1.22"
      ],
      "filament_is_support": [
        "1"
      ],
      "nozzle_temperature": [
        "280"
      ],
      "nozzle_temperature_initial_layer": [
        "280"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "slow_down_layer_time": [
        "6"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS01_01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSS01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSS01_00",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Support W": {
    "filament_id": "GFS00",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "This is a non-water-soluble support filament, and usually it is only for the support structure and not for the model body. To get better printing quality, please refer to this wiki: Printing Tips for Support Filament and Support Function.",
      "cool_plate_temp": [
        "40"
      ],
      "cool_plate_temp_initial_layer": [
        "40"
      ],
      "filament_cost": [
        "69.98"
      ],
      "filament_density": [
        "1.30"
      ],
      "filament_is_support": [
        "1"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS00_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSS00_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "textured_plate_temp": [
          "60"
        ],
        "textured_plate_temp_initial_layer": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSS02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSS00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Support for ABS": {
    "filament_id": "GFS06",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "This is a non-water-soluble support filament, and usually it is only for the support structure and not for the model body. To get better printing quality, please refer to this wiki: Printing Tips for Support Filament and Support Function.",
      "fan_max_speed": [
        "30"
      ],
      "filament_cost": [
        "29.98"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_is_support": [
        "1"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "temperature_vitrification": [
        "90"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS06_01",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSS06_00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "TPU 95A": {
    "filament_id": "GFU01",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "This filament is too soft and not compatible with the AMS. Printing it is of many requirements, and to get better printing quality, please refer to this wiki: TPU printing guide.",
      "filament_cost": [
        "41.99"
      ],
      "filament_density": [
        "1.22"
      ],
      "nozzle_temperature": [
        "230"
      ],
      "nozzle_temperature_initial_layer": [
        "230"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSU01_01",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "3.6"
        ],
        "hot_plate_temp": [
          "45"
        ],
        "hot_plate_temp_initial_layer": [
          "45"
        ],
        "textured_plate_temp": [
          "45"
        ],
        "textured_plate_temp_initial_layer": [
          "45"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSU01_00",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "3.6"
        ],
        "hot_plate_temp": [
          "30"
        ],
        "hot_plate_temp_initial_layer": [
          "30"
        ],
        "textured_plate_temp": [
          "30"
        ],
        "textured_plate_temp_initial_layer": [
          "30"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSU01",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "3.6"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSU00",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "3.6"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "TPU 95A HF": {
    "filament_id": "GFU00",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "This filament is too soft and not compatible with the AMS. Printing it is of many requirements, and to get better printing quality, please refer to this wiki: TPU printing guide.",
      "filament_cost": [
        "41.99"
      ],
      "filament_density": [
        "1.22"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_retraction_length": [
        "0.8"
      ],
      "nozzle_temperature": [
        "230"
      ],
      "nozzle_temperature_initial_layer": [
        "230"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSU00_06",
        "instantiation": "true",
        "hot_plate_temp": [
          "45"
        ],
        "hot_plate_temp_initial_layer": [
          "45"
        ],
        "textured_plate_temp": [
          "45"
        ],
        "textured_plate_temp_initial_layer": [
          "45"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSU00_05",
        "instantiation": "true",
        "hot_plate_temp": [
          "30"
        ],
        "hot_plate_temp_initial_layer": [
          "30"
        ],
        "textured_plate_temp": [
          "30"
        ],
        "textured_plate_temp_initial_layer": [
          "30"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSU00_02",
        "instantiation": "true",
        "hot_plate_temp": [
          "45"
        ],
        "hot_plate_temp_initial_layer": [
          "45"
        ],
        "textured_plate_temp": [
          "45"
        ],
        "textured_plate_temp_initial_layer": [
          "45"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "P1S": {
        "setting_id": "GFSU00_03",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSU00_01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSU00_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSU00_04",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "TPU for AMS": {
    "filament_id": "GFU02",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "description": "If you are to print a kind of soft TPU, please don't slice with this profile, and it is only for TPU that has high enough hardness (not less than 55D) and is compatible with the AMS. To get better printing quality, please refer to this wiki: TPU printing guide.",
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "50"
      ],
      "fan_min_speed": [
        "20"
      ],
      "filament_cost": [
        "38.99"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_flow_ratio": [
        "0.97"
      ],
      "filament_max_volumetric_speed": [
        "18"
      ],
      "filament_type": [
        "TPU-AMS"
      ],
      "nozzle_temperature": [
        "230"
      ],
      "nozzle_temperature_initial_layer": [
        "230"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature_range_low": [
        "220"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "slow_down_layer_time": [
        "10"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSU02_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSU02_03",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSU02_01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSU02_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      }
    }
  },
  "Fiberon PA12-CF": {
    "filament_id": "GFL52",
    "vendor": "Polymaker",
    "base_settings": {
      "instantiation": "false",
      "eng_plate_temp": [
        "40"
      ],
      "eng_plate_temp_initial_layer": [
        "40"
      ],
      "fan_cooling_layer_time": [
        "15"
      ],
      "fan_max_speed": [
        "100"
      ],
      "filament_cost": [
        "99.99"
      ],
      "filament_density": [
        "1.06"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "14"
      ],
      "filament_type": [
        "PA-CF"
      ],
      "full_fan_speed_layer": [
        "2"
      ],
      "hot_plate_temp": [
        "40"
      ],
      "hot_plate_temp_initial_layer": [
        "40"
      ],
      "nozzle_temperature": [
        "300"
      ],
      "nozzle_temperature_initial_layer": [
        "300"
      ],
      "nozzle_temperature_range_low": [
        "260"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "temperature_vitrification": [
        "131"
      ],
      "textured_plate_temp": [
        "40"
      ],
      "textured_plate_temp_initial_layer": [
        "40"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSL52_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      }
    }
  },
  "Fiberon PA6-CF": {
    "filament_id": "GFL50",
    "vendor": "Polymaker",
    "base_settings": {
      "instantiation": "false",
      "eng_plate_temp": [
        "40"
      ],
      "eng_plate_temp_initial_layer": [
        "40"
      ],
      "fan_cooling_layer_time": [
        "15"
      ],
      "fan_max_speed": [
        "100"
      ],
      "filament_cost": [
        "83.99"
      ],
      "filament_density": [
        "1.17"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "14"
      ],
      "filament_type": [
        "PA6-CF"
      ],
      "hot_plate_temp": [
        "40"
      ],
      "hot_plate_temp_initial_layer": [
        "40"
      ],
      "nozzle_temperature": [
        "300"
      ],
      "nozzle_temperature_initial_layer": [
        "300"
      ],
      "nozzle_temperature_range_low": [
        "280"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "temperature_vitrification": [
        "215"
      ],
      "textured_plate_temp": [
        "40"
      ],
      "textured_plate_temp_initial_layer": [
        "40"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSL50_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      }
    }
  },
  "Fiberon PA6-GF": {
    "filament_id": "GFL51",
    "vendor": "Polymaker",
    "base_settings": {
      "instantiation": "false",
      "eng_plate_temp": [
        "40"
      ],
      "eng_plate_temp_initial_layer": [
        "40"
      ],
      "fan_cooling_layer_time": [
        "15"
      ],
      "fan_max_speed": [
        "100"
      ],
      "filament_cost": [
        "63.99"
      ],
      "filament_density": [
        "1.2"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_type": [
        "PA-GF"
      ],
      "full_fan_speed_layer": [
        "2"
      ],
      "hot_plate_temp": [
        "40"
      ],
      "hot_plate_temp_initial_layer": [
        "40"
      ],
      "nozzle_temperature": [
        "300"
      ],
      "nozzle_temperature_initial_layer": [
        "300"
      ],
      "nozzle_temperature_range_low": [
        "280"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "temperature_vitrification": [
        "191"
      ],
      "textured_plate_temp": [
        "40"
      ],
      "textured_plate_temp_initial_layer": [
        "40"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSL51_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle"
        ]
      }
    }
  },
  "Fiberon PA612-CF": {
    "filament_id": "GFL53",
    "vendor": "Bambu Lab",
    "base_settings": {
      "instantiation": "false",
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "94.99"
      ],
      "filament_density": [
        "1.06"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "full_fan_speed_layer": [
        "2"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "temperature_vitrification": [
        "180"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSL53_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle"
        ]
      }
    }
  },
  "Fiberon PET-CF": {
    "filament_id": "GFL54",
    "vendor": "Polymaker",
    "base_settings": {
      "instantiation": "false",
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "242"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "89.99"
      ],
      "filament_density": [
        "1.34"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_type": [
        "PET-CF"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature": [
        "300"
      ],
      "nozzle_temperature_initial_layer": [
        "300"
      ],
      "nozzle_temperature_range_high": [
        "300"
      ],
      "nozzle_temperature_range_low": [
        "270"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "supertack_plate_temp": [
        "80"
      ],
      "supertack_plate_temp_initial_layer": [
        "80"
      ],
      "slow_down_layer_time": [
        "5"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "147"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSL54_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle"
        ]
      }
    }
  },
  "Fiberon PETG-ESD": {
    "filament_id": "GFL06",
    "vendor": "Polymaker",
    "base_settings": {
      "instantiation": "false",
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "eng_plate_temp": [
        "60"
      ],
      "eng_plate_temp_initial_layer": [
        "60"
      ],
      "fan_cooling_layer_time": [
        "15"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "0"
      ],
      "filament_density": [
        "1.24"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "20"
      ],
      "hot_plate_temp": [
        "60"
      ],
      "hot_plate_temp_initial_layer": [
        "60"
      ],
      "nozzle_temperature": [
        "290"
      ],
      "nozzle_temperature_initial_layer": [
        "290"
      ],
      "nozzle_temperature_range_high": [
        "290"
      ],
      "nozzle_temperature_range_low": [
        "250"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "76"
      ],
      "textured_plate_temp": [
        "60"
      ],
      "textured_plate_temp_initial_layer": [
        "60"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSL06_00",
        "instantiation": "true",
        "filament_cost": [
          "29.99"
        ],
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle"
        ]
      }
    }
  },
  "Fiberon PETG-rCF": {
    "filament_id": "GFL55",
    "vendor": "Polymaker",
    "base_settings": {
      "instantiation": "false",
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "12"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "39.99"
      ],
      "filament_density": [
        "1.3"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_type": [
        "PETG-CF"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature": [
        "270"
      ],
      "nozzle_temperature_initial_layer": [
        "270"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSL55_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      }
    }
  },
  "Generic ABS": {
    "filament_id": "GFB99",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "description": "When printing this filament, there's a risk of warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials.",
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "16"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB99_05",
        "instantiation": "true",
        "fan_max_speed": [
          "20"
        ],
        "filament_max_volumetric_speed": [
          "15"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSB99_03",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Generic ASA": {
    "filament_id": "GFB98",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "description": "When printing this filament, there's a risk of warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials.",
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB98_04",
        "instantiation": "true",
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSB98_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Generic BVOH": {
    "filament_id": "GFS97",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false"
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS97_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSS97_01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSS97_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      }
    }
  },
  "Generic EVA": {
    "filament_id": "GFR99",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "additional_cooling_fan_speed": [
        "70"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "21.99"
      ],
      "filament_density": [
        "0.94"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature": [
        "210"
      ],
      "nozzle_temperature_initial_layer": [
        "210"
      ],
      "nozzle_temperature_range_high": [
        "220"
      ],
      "nozzle_temperature_range_low": [
        "175"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSR99_01",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSR99_02",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSR99_00",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Generic HIPS": {
    "filament_id": "GFS98",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "filament_is_support": [
        "1"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS98_04",
        "instantiation": "true",
        "eng_plate_temp": [
          "70"
        ],
        "eng_plate_temp_initial_layer": [
          "70"
        ],
        "hot_plate_temp": [
          "70"
        ],
        "hot_plate_temp_initial_layer": [
          "70"
        ],
        "textured_plate_temp": [
          "70"
        ],
        "textured_plate_temp_initial_layer": [
          "70"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSS98_02",
        "instantiation": "true",
        "eng_plate_temp": [
          "70"
        ],
        "eng_plate_temp_initial_layer": [
          "70"
        ],
        "hot_plate_temp": [
          "70"
        ],
        "hot_plate_temp_initial_layer": [
          "70"
        ],
        "textured_plate_temp": [
          "70"
        ],
        "textured_plate_temp_initial_layer": [
          "70"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSS98_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Generic PC": {
    "filament_id": "GFC99",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "description": "When printing this filament, there's a risk of warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials.",
      "filament_flow_ratio": [
        "0.94"
      ],
      "filament_max_volumetric_speed": [
        "16"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSC99_07",
        "instantiation": "true",
        "eng_plate_temp": [
          "100"
        ],
        "eng_plate_temp_initial_layer": [
          "100"
        ],
        "fan_max_speed": [
          "20"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "P1S": {
        "setting_id": "GFSC99_04",
        "instantiation": "true",
        "eng_plate_temp": [
          "100"
        ],
        "eng_plate_temp_initial_layer": [
          "100"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSC99_06",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Generic PCTG": {
    "filament_id": "GFG97",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "40"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "28.99"
      ],
      "filament_density": [
        "1.29"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "temperature_vitrification": [
        "90"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG97_01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSG97_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSG97_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Generic PE": {
    "filament_id": "GFP99",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "40.99"
      ],
      "filament_density": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "nozzle_temperature": [
        "210"
      ],
      "nozzle_temperature_initial_layer": [
        "210"
      ],
      "nozzle_temperature_range_high": [
        "220"
      ],
      "nozzle_temperature_range_low": [
        "175"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSP99_01",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSP99_02",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSP99_00",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Generic PE-CF": {
    "filament_id": "GFP98",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "65.99"
      ],
      "filament_density": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_type": [
        "PE-CF"
      ],
      "nozzle_temperature": [
        "210"
      ],
      "nozzle_temperature_initial_layer": [
        "210"
      ],
      "nozzle_temperature_range_high": [
        "220"
      ],
      "nozzle_temperature_range_low": [
        "175"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSP98_01",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSP98_02",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSP98_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Generic PETG": {
    "filament_id": "GFG99",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "90"
      ],
      "fan_min_speed": [
        "40"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG99_03",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "8"
        ],
        "hot_plate_temp": [
          "80"
        ],
        "hot_plate_temp_initial_layer": [
          "80"
        ],
        "textured_plate_temp": [
          "80"
        ],
        "textured_plate_temp_initial_layer": [
          "80"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSG99_00",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      }
    }
  },
  "Generic PETG HF": {
    "filament_id": "GFG96",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "40"
      ],
      "filament_cost": [
        "24.99"
      ],
      "filament_density": [
        "1.28"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "16"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "slow_down_layer_time": [
        "25"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG96_04",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSG96_06",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSG96_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSG96_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle"
        ]
      }
    }
  },
  "Generic PETG-CF": {
    "filament_id": "GFG98",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "34.99"
      ],
      "filament_density": [
        "1.25"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_type": [
        "PETG-CF"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "slow_down_layer_time": [
        "6"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG98_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "30"
        ],
        "fan_max_speed": [
          "40"
        ],
        "fan_min_speed": [
          "5"
        ],
        "filament_max_volumetric_speed": [
          "8"
        ],
        "overhang_fan_speed": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSG50",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "30"
        ],
        "fan_max_speed": [
          "40"
        ],
        "fan_min_speed": [
          "5"
        ],
        "filament_max_volumetric_speed": [
          "11.5"
        ],
        "overhang_fan_speed": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Generic PHA": {
    "filament_id": "GFR98",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false"
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSR98_02",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle",
          "Bambu Lab A1 0.4 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSR98_01",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSR98_00",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1P 0.4 nozzle"
        ]
      }
    }
  },
  "Generic PLA": {
    "filament_id": "GFL99",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "description": "The generic presets are conservatively tuned for compatibility with a wider range of filaments. For higher printing quality and speeds, please use Bambu filaments with Bambu presets.",
      "filament_flow_ratio": [
        "0.98"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif};Prevent PLA from jamming\n\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL99_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL99_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      }
    }
  },
  "Generic PLA High Speed": {
    "filament_id": "GFL95",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_max_volumetric_speed": [
        "18"
      ],
      "slow_down_layer_time": [
        "8"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL95_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL95_06",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle",
          "Bambu Lab A1 mini 0.4 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSL95_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSL95_00",
        "instantiation": "true",
        "slow_down_layer_time": [
          "4"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "Generic PLA Silk": {
    "filament_id": "GFL96",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "description": "To make the prints get higher gloss, please dry the filament before use, and set the outer wall speed to be 40 to 60 mm/s when slicing.",
      "filament_flow_ratio": [
        "0.98"
      ],
      "supertack_plate_temp": [
        "35"
      ],
      "supertack_plate_temp_initial_layer": [
        "35"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif};Prevent PLA from jamming\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL96_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "7.5"
        ],
        "filament_retraction_length": [
          "0.5"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL96_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "7.5"
        ],
        "filament_retraction_length": [
          "0.5"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "textured_plate_temp": [
          "60"
        ],
        "textured_plate_temp_initial_layer": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      }
    }
  },
  "Generic PLA-CF": {
    "filament_id": "GFL98",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "additional_cooling_fan_speed": [
        "0"
      ],
      "cool_plate_temp": [
        "45"
      ],
      "cool_plate_temp_initial_layer": [
        "45"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_type": [
        "PLA-CF"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "supertack_plate_temp": [
        "50"
      ],
      "supertack_plate_temp_initial_layer": [
        "50"
      ],
      "slow_down_layer_time": [
        "7"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL98_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL98_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      }
    }
  },
  "Generic PP": {
    "filament_id": "GFP97",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false"
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSP97_01",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSP97_02",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSP97_00",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Generic PP-CF": {
    "filament_id": "GFP96",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "77.99"
      ],
      "filament_density": [
        "1.01"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_type": [
        "PP-CF"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSP96_01",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSP96_00",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Generic PP-GF": {
    "filament_id": "GFP95",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "59.99"
      ],
      "filament_density": [
        "1.05"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_type": [
        "PP-GF"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSP95_00",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSP97_03",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Generic PPA-CF": {
    "filament_id": "GFN97",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials.",
      "filament_max_volumetric_speed": [
        "6"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSN97_00",
        "instantiation": "true",
        "fan_max_speed": [
          "35"
        ],
        "filament_max_volumetric_speed": [
          "6.5"
        ],
        "overhang_fan_threshold": [
          "25%"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSN97_01",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "fan_max_speed": [
          "35"
        ],
        "filament_max_volumetric_speed": [
          "6.5"
        ],
        "overhang_fan_threshold": [
          "25%"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Generic PPA-GF": {
    "filament_id": "GFN96",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_type": [
        "PPA-GF"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSN96_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSN96_01",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "Generic PPS": {
    "filament_id": "GFT97",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false"
    },
    "model_settings": {
      "X1E": {
        "setting_id": "GFST97_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "Generic PPS-CF": {
    "filament_id": "GFT98",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials.",
      "fan_max_speed": [
        "30"
      ],
      "filament_cost": [
        "240"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_max_volumetric_speed": [
        "3"
      ],
      "filament_type": [
        "PPS-CF"
      ],
      "nozzle_temperature_range_low": [
        "310"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "temperature_vitrification": [
        "220"
      ]
    },
    "model_settings": {
      "X1E": {
        "setting_id": "GFST98_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle"
        ]
      }
    }
  },
  "Generic PVA": {
    "filament_id": "GFS99",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "description": "This is a water-soluble support filament, and usually it is only for the support structure and not for the model body. Printing this filament is of many requirements, and to get better printing quality, please refer to this wiki: PVA Printing Guide.",
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "16"
      ],
      "slow_down_layer_time": [
        "7"
      ],
      "slow_down_min_speed": [
        "20"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS99_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSS99_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle",
          "Bambu Lab A1 mini 0.4 nozzle"
        ]
      }
    }
  },
  "Generic TPU for AMS": {
    "filament_id": "GFU98",
    "vendor": "Generic",
    "base_settings": {
      "instantiation": "false",
      "description": "If you are to print a kind of soft TPU, please don't slice with this profile, and it is only for TPU that has high enough hardness (not less than 55D) and is compatible with the AMS. To get better printing quality, please refer to this wiki: TPU printing guide.",
      "filament_cost": [
        "41.99"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_max_volumetric_speed": [
        "10.5"
      ],
      "filament_retraction_length": [
        "0.8"
      ],
      "filament_type": [
        "TPU-AMS"
      ],
      "nozzle_temperature": [
        "230"
      ],
      "nozzle_temperature_initial_layer": [
        "230"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSU98_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "40"
        ],
        "fan_max_speed": [
          "50"
        ],
        "fan_min_speed": [
          "10"
        ],
        "overhang_fan_threshold": [
          "25%"
        ],
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSU98_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "40"
        ],
        "fan_max_speed": [
          "50"
        ],
        "fan_min_speed": [
          "10"
        ],
        "overhang_fan_threshold": [
          "25%"
        ],
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.8 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.4 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSU98_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "40"
        ],
        "fan_max_speed": [
          "50"
        ],
        "fan_min_speed": [
          "10"
        ],
        "overhang_fan_threshold": [
          "25%"
        ],
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSU98_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "40"
        ],
        "fan_max_speed": [
          "50"
        ],
        "fan_min_speed": [
          "10"
        ],
        "overhang_fan_threshold": [
          "25%"
        ],
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "Overture Matte PLA": {
    "filament_id": "GFL05",
    "vendor": "Overture",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "24.52"
      ],
      "filament_density": [
        "1.22"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_max_volumetric_speed": [
        "16"
      ],
      "slow_down_layer_time": [
        "6"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL05_07",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL05_05",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSL05_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "10"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSL05_02",
        "instantiation": "true",
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "X1C": {
        "setting_id": "GFSL05_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "Overture PLA": {
    "filament_id": "GFL04",
    "vendor": "Overture",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "24.15"
      ],
      "filament_density": [
        "1.2"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_max_volumetric_speed": [
        "15"
      ],
      "slow_down_layer_time": [
        "6"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL04_07",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL04_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSL04_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSL04_01",
        "instantiation": "true",
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "X1C": {
        "setting_id": "GFSL04_05",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "PolyLite ABS": {
    "filament_id": "GFB60",
    "vendor": "Polymaker",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "26.9"
      ],
      "filament_density": [
        "1.03"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "15"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB60_06",
        "instantiation": "true",
        "fan_max_speed": [
          "20"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSB60_04",
        "instantiation": "true",
        "fan_max_speed": [
          "20"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSB60_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSB60_01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "PolyLite ASA": {
    "filament_id": "GFB61",
    "vendor": "Polymaker",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "23.6"
      ],
      "filament_density": [
        "1.02"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_max_volumetric_speed": [
        "13"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB61_07",
        "instantiation": "true",
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSB61_04",
        "instantiation": "true",
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSB61_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSB61_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "PolyLite PETG": {
    "filament_id": "GFG60",
    "vendor": "Polymaker",
    "base_settings": {
      "instantiation": "false",
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "90"
      ],
      "fan_min_speed": [
        "40"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG60_06",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "8"
        ],
        "hot_plate_temp": [
          "80"
        ],
        "hot_plate_temp_initial_layer": [
          "80"
        ],
        "nozzle_temperature_range_high": [
          "270"
        ],
        "textured_plate_temp": [
          "80"
        ],
        "textured_plate_temp_initial_layer": [
          "80"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle",
          "Bambu Lab A1 0.4 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSG60_04",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "8"
        ],
        "nozzle_temperature_range_high": [
          "270"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSG60_02",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "11.5"
        ],
        "hot_plate_temp": [
          "80"
        ],
        "hot_plate_temp_initial_layer": [
          "80"
        ],
        "nozzle_temperature_range_high": [
          "270"
        ],
        "textured_plate_temp": [
          "80"
        ],
        "textured_plate_temp_initial_layer": [
          "80"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSG60_00",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "11.5"
        ],
        "nozzle_temperature_range_high": [
          "270"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "PolyLite PLA": {
    "filament_id": "GFL00",
    "vendor": "Polymaker",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "25.4"
      ],
      "filament_flow_ratio": [
        "0.95"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL00_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "15"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL00_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "15"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSL23",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "15"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "X1C": {
        "setting_id": "GFSL19",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "15"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "PolyTerra PLA": {
    "filament_id": "GFL01",
    "vendor": "Polymaker",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "25.4"
      ],
      "filament_density": [
        "1.31"
      ],
      "filament_flow_ratio": [
        "0.98"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL01_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "22"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL01_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "22"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSL22",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "22"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "X1C": {
        "setting_id": "GFSL18",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "22"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "eSUN PLA+": {
    "filament_id": "GFL03",
    "vendor": "eSUN",
    "base_settings": {
      "instantiation": "false",
      "filament_cost": [
        "22.99"
      ],
      "filament_density": [
        "1.25"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_max_volumetric_speed": [
        "16"
      ],
      "slow_down_layer_time": [
        "6"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL03_05",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL03_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSL03_02",
        "instantiation": "true",
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSL03_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  }
};

/**
 * Get the filament ID for a given material type
 * @param materialType The type of material (e.g., "PLA Basic", "ABS")
 * @returns The filament ID or null if not found
 */
export function getFilamentId(materialType: string): string | null {
    const profile = FILAMENT_MAPPINGS[materialType.trim()];
    return profile ? profile.filament_id : null;
}

/**
 * Get all settings for a material type and printer model
 * @param materialType The type of material (e.g., "PLA Basic", "ABS")
 * @param printerModel The printer model (e.g., "X1C", "A1")
 * @returns Combined settings (base + model specific) or null if not found
 */
export function getMaterialSettings(materialType: string, printerModel: string): any | null {
    const normalizedMaterial = materialType.trim();
    const normalizedPrinter = printerModel.replace("BBL ", "").trim();

    const profile = FILAMENT_MAPPINGS[normalizedMaterial];
    if (!profile) return null;

    const modelSettings = profile.model_settings[normalizedPrinter];
    if (!modelSettings) return null;

    return {
        ...profile.base_settings,
        ...modelSettings,
        filament_id: profile.filament_id,
        vendor: profile.vendor
    };
}

/**
 * List all compatible materials for a given printer model
 * @param printerModel The printer model (e.g., "X1C", "A1")
 * @returns Array of compatible material types
 */
export function getCompatibleMaterials(printerModel: string): string[] {
    const normalizedPrinter = printerModel.replace("BBL ", "").trim();
    
    return Object.entries(FILAMENT_MAPPINGS)
        .filter(([_, profile]) => normalizedPrinter in profile.model_settings)
        .map(([materialType]) => materialType);
}

/**
 * Get all supported printer models
 * @returns Array of supported printer models
 */
export function getSupportedPrinters(): string[] {
    const printers = new Set<string>();
    
    Object.values(FILAMENT_MAPPINGS).forEach(profile => {
        Object.keys(profile.model_settings).forEach(printer => {
            printers.add(printer);
        });
    });
    
    return Array.from(printers);
}

/**
 * Check if a material type exists in the mapping
 * @param materialType The material type to check
 * @returns boolean indicating if the material type exists
 */
export function isMaterialTypeSupported(materialType: string): boolean {
    return materialType.trim() in FILAMENT_MAPPINGS;
}

/**
 * Get the vendor for a given material type
 * @param materialType The material type
 * @returns The vendor name or null if material type not found
 */
export function getMaterialVendor(materialType: string): string | null {
    const profile = FILAMENT_MAPPINGS[materialType.trim()];
    return profile ? profile.vendor : null;
}

/**
 * Get base settings for a material type
 * @param materialType The type of material (e.g., "PLA Basic", "ABS")
 * @returns Base settings or null if not found
 */
export function getBaseSettings(materialType: string): any | null {
    const profile = FILAMENT_MAPPINGS[materialType.trim()];
    return profile ? profile.base_settings : null;
}

/**
 * Get settings for a material type and printer model, with fallback to defaults
 * @param materialType The type of material (e.g., "PLA Basic", "ABS")
 * @param printerModel The printer model (e.g., "X1C", "A1")
 * @returns Combined settings (model-specific + base) or null if material not found
 */
export function getFilamentSettings(materialType: string, printerModel: string): any | null {
    const normalizedMaterial = materialType.trim();
    const normalizedPrinter = printerModel.replace("BBL ", "").trim();

    const profile = FILAMENT_MAPPINGS[normalizedMaterial];
    if (!profile) return null;

    // Start with base settings
    const settings = {
        filament_id: profile.filament_id,
        vendor: profile.vendor,
        ...profile.base_settings
    };

    // If model-specific settings exist, override base settings
    const modelSettings = profile.model_settings[normalizedPrinter];
    if (modelSettings) {
        return {
            ...settings,
            ...modelSettings
        };
    }

    return settings;
}

/**
 * Check if model-specific settings exist for a material and printer combination
 * @param materialType The type of material (e.g., "PLA Basic", "ABS")
 * @param printerModel The printer model (e.g., "X1C", "A1")
 * @returns boolean indicating if model-specific settings exist
 */
export function hasModelSpecificSettings(materialType: string, printerModel: string): boolean {
    const normalizedMaterial = materialType.trim();
    const normalizedPrinter = printerModel.replace("BBL ", "").trim();

    const profile = FILAMENT_MAPPINGS[normalizedMaterial];
    return profile ? normalizedPrinter in profile.model_settings : false;
}

/**
 * Get a specific setting value for a material and printer combination
 * @param materialType The type of material (e.g., "PLA Basic", "ABS")
 * @param printerModel The printer model (e.g., "X1C", "A1")
 * @param settingKey The setting key to retrieve
 * @returns The setting value or null if not found
 */
export function getFilamentSetting(materialType: string, printerModel: string, settingKey: string): any | null {
    const settings = getFilamentSettings(materialType, printerModel);
    if (!settings) return null;

    return settings[settingKey] ?? null;
}

/**
 * Get all available setting keys for a material type
 * @param materialType The type of material (e.g., "PLA Basic", "ABS")
 * @returns Array of setting keys or empty array if material not found
 */
export function getAvailableSettings(materialType: string): string[] {
    const profile = FILAMENT_MAPPINGS[materialType.trim()];
    if (!profile) return [];

    const baseKeys = Object.keys(profile.base_settings);
    const modelKeys = new Set<string>();

    // Collect all unique setting keys from model-specific settings
    Object.values(profile.model_settings).forEach(modelSettings => {
        Object.keys(modelSettings).forEach(key => modelKeys.add(key));
    });

    return [...new Set([...baseKeys, ...modelKeys])];
}